import { Box, convertHexToRGBA, Icon, Spacer, Text, TextProps } from '@jfs/ui-new'
import { MerchantTheme } from '../../../data/models/Config'

interface InfoHeaderProps {
  mobileNo: string
  theme: any
  onEditPress: any
  type: string
}

const typeMap = {
  debitCardEmi: 'Debit Card EMI',
  cardlessEmi: 'Cardless EMI',
  payLaterEmi: 'Buy Now Pay Later EMI',
}

export const InfoHeader = ({ mobileNo, theme, onEditPress, type }: InfoHeaderProps) => {
  const styles = stylesFun(theme)
  return (
    <Box backgroundColor={convertHexToRGBA(theme.bodyTextColor, 10) as any} pv={16} ph={24}>
      <Box flexDirection={'row'}>
        <Text {...styles.title}>Congrats!</Text>
        <Spacer size={16} direction="horizontal" />
        <Text {...styles.mobileNo}>+91 {mobileNo}</Text>
        <Box mt={1} onPress={onEditPress} underlayColor="TRANSPARENT" ml={8}>
          <Icon id={'EDIT'} color={theme.brandColor} size={14} />
        </Box>
      </Box>
      <Spacer size={10} />
      <Text {...styles.description}>{`You are eligible for ${
        typeMap[type as keyof typeof typeMap]
      } from below banks.`}</Text>
    </Box>
  )
}

const stylesFun = (theme: typeof MerchantTheme.properties) => ({
  title: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: theme.bodyTextColor as any,
  } as TextProps,
  mobileNo: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: theme.brandColor as any,
  } as TextProps,
  description: {
    fontSize: 12,
    fontFamily: 'jioType-light',
    color: convertHexToRGBA(theme.bodyTextColor, 50) as any,
  },
})
